import React from 'react';

const GiftListCheckbox = (props) => {
    

    const buildAvatarUrl = (userData) => {
        if(userData.hasOwnProperty('avatarFile') && userData.avatarFile && (userData.avatarFile.indexOf('_avatar') > 0 || userData.avatarFile.length > 30)) {
	        return <img className="avatar avatar-xs" src={"https://weblight.imgix.net/avatars/"+userData.avatarFile + "?w=100&h=100&fit=facearea&faceindex=1&facepad=2"} alt="" />;
	    }
	    // if(userData.FBID && userData.FBID !== "0") {
	    //     return <img className="avatar avatar-xs" src={"https://graph.facebook.com/" + userData.FBID + "/picture?type=large"} alt="" />;
        // }
        return (<div className="kt-media kt-media--xs kt-media--circle kt-media--info">
            <span>{userData.FirstName ? userData.FirstName.charAt(0) : '?'}{userData.LastName ? userData.LastName.charAt(0) : ''}</span>
        </div>);
    }

    return (
        <>
            <label key={props.userID} className="kt-checkbox kt-checkbox--success mb-1">
                <input type="checkbox" defaultChecked={props.checked} value={props.userID} onChange={props.handler} /> {buildAvatarUrl(props)} {props.FirstName} {props.LastName}
                <span></span>
            </label>
        </>);
}
export default GiftListCheckbox;